import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';
import CloseIcon from '@atlaskit/icon/core/close';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	dismissIconLabel: {
		id: 'experiment-home-onboarding-takeover-v2.dismiss-icon-label',
		defaultMessage: 'Dismiss banner',
		description:
			'This text is shown as a label for a dismiss/cross icon for accessibility. The icon can then be used to close/dismiss the banner',
	},
});

const dismissIconStyles = xcss({
	position: 'absolute',
	top: 'space.100',
	right: 'space.100',
	cursor: 'pointer',
});

export const HTV2DismissIcon = () => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={dismissIconStyles}>
			<CloseIcon label={formatMessage(i18n.dismissIconLabel)} color={token('color.icon')} />
		</Box>
	);
};
